module.exports = __webpack_public_path__ + "assets/bf771bf8f8159e1f67f72989fc7519e0.mp3";